itsoftApp.createModule("headerFix", ["pageLoad", "windowScroll", "windowResize"], function () {
    var header = document.querySelector(".page-header");
    var pageWrapper = document.querySelector(".l-wrapper");
    var chooseFixed = document.querySelector('.js-choose-fixed');
    var chooseTrigger = document.querySelector('.accordion-instruction');
    var headerFixed = false;
    var pagePaddingElements = document.querySelectorAll(".js-padding");
    var headerHeight;
    var chooseOffset;
    var fixedNav = document.querySelector('.js-fixed-nav');

    var setPagePadding = function () {
        if (pagePaddingElements) {
            Array.prototype.forEach.call(pagePaddingElements, function (pagePadding) {
                pagePadding.style.paddingTop = headerHeight + "px";
            });
        } else {
            pageWrapper.style.paddingTop = headerHeight + "px";
        }
    };

    var updateHeaderHeight = function () {
        if (header) {
            headerHeight = itsoftApp.utils.getHeaderHeight();
            setPagePadding();
        }
    };

    var modifyHeader = function () {
        if (scrollY > 0 && !headerFixed) {
            header.classList.add("js-fixed");
            headerFixed = true;
        } else if (scrollY === 0) {
            header.classList.remove("js-fixed");
            headerFixed = false;
        }
    };

    var modifyChoose = function () {
        chooseOffset = chooseTrigger.offsetTop - (chooseTrigger.offsetTop / 2);
        if (scrollY >= chooseOffset) {
            chooseFixed.classList.add('_show');
            chooseFixed.style.transform = `translateY(${headerHeight - 1}px)`
        } else {
            chooseFixed.classList.remove('_show');
            chooseFixed.style.transform = `translateY(0)`
        }
    }

    if (header) {
        itsoftApp.modules.pageLoad.addEvent(function () {
            headerHeight = itsoftApp.utils.getHeaderHeight();
            itsoftApp.modules.windowResize.addEvent(updateHeaderHeight);
            itsoftApp.modules.windowScroll.addEvent(modifyHeader);

            if (chooseFixed) {
                itsoftApp.modules.windowResize.addEvent(modifyChoose);
                itsoftApp.modules.windowScroll.addEvent(modifyChoose);
            }

            modifyHeader();
            setPagePadding();
            
            if (chooseFixed) {
                modifyChoose();
            }

            if (fixedNav) {
                header.classList.add('page-header--no-radius');
            }
        });
    }
});